export const PERMANENT_HARD_REFRESH_REQUIRED: string[] = [
    '/lokos-transaction/',
];
